module.exports = __webpack_public_path__ + "img/banner2.76e264c7.png";